// extracted by css-extract-rspack-plugin
var _1 = "ai-attribute-tags-RBw_7p";
var _2 = "ai-extractor-tags-x28_4S";
var _3 = "ai-attribute-tags-RBw_7p";
var _4 = "ai-extractor-tags-x28_4S";
var _5 = "filter-raq6oq";
var _6 = "model-cell-eugUWo";
var _7 = "model-tags-d7Z7s0";
var _8 = "model-cell-eugUWo";
var _9 = "model-tags-d7Z7s0";
var _a = "name-cell-CByer8";
var _b = "name-cell-CByer8";
var _c = "table-QghP6s";
export { _1 as "ai-attribute-tags", _2 as "ai-extractor-tags", _3 as "aiAttributeTags", _4 as "aiExtractorTags", _5 as "filter", _6 as "model-cell", _7 as "model-tags", _8 as "modelCell", _9 as "modelTags", _a as "name-cell", _b as "nameCell", _c as "table" }
